import { Truck, ShieldCheck, Tag, Package } from "lucide-react";

const ITEMS = [
  { Icon: Truck, judul: "Gratis Ongkir", ket: "Ke Seluruh Indonesia", nota: "*s&k berlaku" },
  { Icon: ShieldCheck, judul: "Kualitas Terjamin", ket: "Food-Grade & Bersertifikat Uji Lab" },
  { Icon: Tag, judul: "Harga Grosir", ket: "Makin Pesan Banyak Makin Murah" },
  { Icon: Package, judul: "Stok Siap Kirim", ket: "Pesan online kapan saja, 24 jam" },
];

export function AdvantageStrip() {
  return (
    <section className="hsv5-on-dark bg-[#1D1D1F] border-t border-[#333336]" data-testid="advantage-strip">
      {/* Desktop */}
      <div className="v5-adv-strip">
        {ITEMS.map(({ Icon, judul, ket, nota }) => (
          <div key={judul} className="flex items-center gap-[10px]" data-testid={`advantage-${judul.toLowerCase().replace(/\s+/g, "-")}`}>
            <Icon size={36} strokeWidth={1.4} className="shrink-0 text-[#FF6B1A]" />
            <div className="v5-adv-text">
              <div className="text-base font-medium text-white leading-tight">{judul}</div>
              <div className="text-sm text-[#AAAAAA] leading-snug">{ket}</div>
              {nota && <div className="text-[11px] text-[#8E8E93] leading-snug">{nota}</div>}
            </div>
          </div>
        ))}
      </div>
      {/* Mobile: hanya ikon + judul satu baris */}
      <div className="v5-adv-hp grid md:hidden grid-cols-4">
        {ITEMS.map(({ Icon, judul }) => (
          <div key={judul} className="flex flex-col items-center min-w-0"
               data-testid={`advantage-hp-${judul.toLowerCase().replace(/\s+/g, "-")}`}>
            <Icon size={18} strokeWidth={1.4} className="shrink-0 text-[#FF6B1A]" />
            <div className="v5-adv-hp-judul">{judul}</div>
          </div>
        ))}
      </div>
    </section>
  );
}
